import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/app/[lang]/corporate-trainings/CaseStudyCarousel.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/Academy.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/Banner/index.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/ClientReview.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/HomeAboutSec.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/root/lp-frontend/src/components/LazyLoader.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/molecules/index.jsx");
;
import(/* webpackMode: "eager" */ "/root/lp-frontend/src/components/ourClients/index.jsx");
